import {
    Badge,
    Button,
    Dialog,
    Heading,
    Pane,
    SelectField, Tab,
    Table,
    Tablist,
    Textarea,
    TextInputField
} from 'evergreen-ui';
import { Formik } from 'formik';
import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';

import {
    approveVacationRequest,
    cancelVacationRequest,
    createVacationRequest,
    getShops,
    getVacationRequests,
    rejectVacationRequest
} from '../actions/ScheduleActions';
import Configuration from '../Config';

const VACATION_TYPES = [
    { value: 'vacation', label: 'Concediu' },
    { value: 'sick', label: 'Medical' },
    { value: 'personal', label: 'Personal' },
    { value: 'unpaid', label: 'Neplătit' },
    { value: 'maternity', label: 'Maternitate' },
    { value: 'paternity', label: 'Paternitate' },
    { value: 'bereavement', label: 'Deces' },
    { value: 'other', label: 'Altele' }
];

const STATUS_COLORS = {
    pending: 'yellow',
    approved: 'green',
    rejected: 'red',
    cancelled: 'neutral'
};

const STATUS_LABELS = {
    pending: 'În așteptare',
    approved: 'Aprobat',
    rejected: 'Respins',
    cancelled: 'Anulat'
};

class VacationRequests extends Component {
    state = {
        selectedTab: 'pending',
        showCreateDialog: false,
        showProcessDialog: false,
        showCancelDialog: false,
        selectedRequest: null,
        processAction: null, // 'approve' or 'reject'
        adminNotes: '',
        filterShopId: null
    };

    // Check if user can manage (approve/reject) vacation requests
    canManage = () => {
        const { user } = this.props;
        return user && user.role && user.role.level >= 2 && user.role.name !== 'Staff';
    }

    componentDidMount() {
        this.loadRequests();
        this.props.dispatch(getShops());
    }

    loadRequests = () => {
        const { filterShopId } = this.state;
        this.props.dispatch(getVacationRequests({
            extraFilters: filterShopId ? { shopId: filterShopId } : {}
        }));
    }

    handleApprove = async () => {
        const { selectedRequest, adminNotes } = this.state;
        await this.props.dispatch(approveVacationRequest(selectedRequest.id, adminNotes));
        this.handleCloseProcessDialog();
        this.loadRequests();
    }

    handleReject = async () => {
        const { selectedRequest, adminNotes } = this.state;
        await this.props.dispatch(rejectVacationRequest(selectedRequest.id, adminNotes));
        this.handleCloseProcessDialog();
        this.loadRequests();
    }

    handleCancel = async () => {
        const { selectedRequest } = this.state;
        await this.props.dispatch(cancelVacationRequest(selectedRequest.id));
        this.handleCloseCancelDialog();
        this.loadRequests();
    }

    handleOpenCancelDialog = (request) => {
        this.setState({
            showCancelDialog: true,
            selectedRequest: request
        });
    }

    handleCloseCancelDialog = () => {
        this.setState({
            showCancelDialog: false,
            selectedRequest: null
        });
    }

    handleCreateRequest = async (values) => {
        await this.props.dispatch(createVacationRequest(values));
        this.setState({ showCreateDialog: false });
        this.loadRequests();
    }

    handleOpenProcessDialog = (request, action) => {
        this.setState({
            showProcessDialog: true,
            selectedRequest: request,
            processAction: action,
            adminNotes: ''
        });
    }

    handleCloseProcessDialog = () => {
        this.setState({
            showProcessDialog: false,
            selectedRequest: null,
            processAction: null,
            adminNotes: ''
        });
    }

    getFilteredRequests = () => {
        const { selectedTab } = this.state;
        const { vacationRequests } = this.props;

        if (selectedTab === 'all') {
            return vacationRequests;
        }

        return vacationRequests.filter(r => r.status === selectedTab);
    }

    render() {
        const { shops } = this.props;
        const {
            selectedTab, showCreateDialog, showProcessDialog,
            selectedRequest, processAction, adminNotes, filterShopId
        } = this.state;

        const filteredRequests = this.getFilteredRequests();

        return (
            <Pane padding={16}>
                <Pane display="flex" justifyContent="space-between" alignItems="center" marginBottom={16}>
                    <Heading size={600}>Cereri Concediu</Heading>
                    <Pane display="flex" gap={8}>
                        <SelectField
                            label=""
                            value={filterShopId || ''}
                            onChange={(e) => this.setState({ filterShopId: e.target.value ? parseInt(e.target.value) : null }, this.loadRequests)}
                            marginBottom={0}
                            width={200}
                        >
                            <option value="">Toate magazinele</option>
                            {shops.map(shop => (
                                <option key={shop.id} value={shop.id}>{shop.name}</option>
                            ))}
                        </SelectField>
                        <Button
                            iconBefore="add"
                            appearance="primary"
                            onClick={() => this.setState({ showCreateDialog: true })}
                        >
                            Cerere Nouă
                        </Button>
                    </Pane>
                </Pane>

                <Tablist marginBottom={16}>
                    {[
                        { key: 'pending', label: 'În Așteptare' },
                        { key: 'approved', label: 'Aprobate' },
                        { key: 'rejected', label: 'Respinse' },
                        { key: 'all', label: 'Toate' }
                    ].map(tab => (
                        <Tab
                            key={tab.key}
                            isSelected={selectedTab === tab.key}
                            onSelect={() => this.setState({ selectedTab: tab.key })}
                        >
                            {tab.label}
                            {tab.key === 'pending' && this.props.pendingVacations.length > 0 && (
                                <Badge color="red" marginLeft={8}>
                                    {this.props.pendingVacations.length}
                                </Badge>
                            )}
                        </Tab>
                    ))}
                </Tablist>

                <Table>
                    <Table.Head>
                        <Table.TextHeaderCell>Angajat</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Magazin</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Tip</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Perioadă</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Zile Lucr.</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Status</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Motiv</Table.TextHeaderCell>
                        <Table.TextHeaderCell>Acțiuni</Table.TextHeaderCell>
                    </Table.Head>
                    <Table.Body>
                        {filteredRequests.map(request => (
                            <Table.Row key={request.id}>
                                <Table.TextCell>
                                    {request.employee?.user?.name || '-'}
                                </Table.TextCell>
                                <Table.TextCell>
                                    {request.employee?.shop?.name || '-'}
                                </Table.TextCell>
                                <Table.TextCell>
                                    {VACATION_TYPES.find(t => t.value === request.type)?.label || request.type}
                                </Table.TextCell>
                                <Table.TextCell>
                                    {moment(request.startDate).format('DD.MM.YYYY')} - {moment(request.endDate).format('DD.MM.YYYY')}
                                </Table.TextCell>
                                <Table.TextCell>
                                    {request.workingDays || '-'}
                                </Table.TextCell>
                                <Table.Cell>
                                    <Badge color={STATUS_COLORS[request.status]}>
                                        {STATUS_LABELS[request.status]}
                                    </Badge>
                                </Table.Cell>
                                <Table.TextCell>
                                    {request.reason ? (
                                        <span title={request.reason}>
                                            {request.reason.length > 30
                                                ? request.reason.substring(0, 30) + '...'
                                                : request.reason}
                                        </span>
                                    ) : '-'}
                                </Table.TextCell>
                                <Table.Cell>
                                    {request.status === 'pending' && this.canManage() && (
                                        <Pane display="flex" gap={4}>
                                            <Button
                                                size="small"
                                                intent="success"
                                                onClick={() => this.handleOpenProcessDialog(request, 'approve')}
                                            >
                                                Aprobă
                                            </Button>
                                            <Button
                                                size="small"
                                                intent="danger"
                                                onClick={() => this.handleOpenProcessDialog(request, 'reject')}
                                            >
                                                Respinge
                                            </Button>
                                        </Pane>
                                    )}
                                    {request.status === 'approved' && this.canManage() && (
                                        <Button
                                            size="small"
                                            intent="danger"
                                            onClick={() => this.handleOpenCancelDialog(request)}
                                        >
                                            Anulează
                                        </Button>
                                    )}
                                    {request.status !== 'pending' && request.adminNotes && (
                                        <span title={request.adminNotes}>📝</span>
                                    )}
                                </Table.Cell>
                            </Table.Row>
                        ))}
                        {filteredRequests.length === 0 && (
                            <Table.Row>
                                <Table.TextCell colSpan={8} textAlign="center">
                                    Nu există cereri de concediu
                                </Table.TextCell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>

                {/* Create Dialog */}
                <Dialog
                    isShown={showCreateDialog}
                    title="Cerere Concediu Nouă"
                    onCloseComplete={() => this.setState({ showCreateDialog: false })}
                    hasFooter={false}
                >
                    <Formik
                        initialValues={Configuration.Defaults.createVacation}
                        validationSchema={Configuration.Validations.vacation}
                        onSubmit={this.handleCreateRequest}
                    >
                        {({ values, errors, handleChange, handleSubmit }) => (
                            <form onSubmit={handleSubmit}>
                                <SelectField
                                    label="Tip Concediu"
                                    name="type"
                                    required
                                    value={values.type}
                                    onChange={handleChange}
                                >
                                    {VACATION_TYPES.map(t => (
                                        <option key={t.value} value={t.value}>{t.label}</option>
                                    ))}
                                </SelectField>

                                <Pane display="flex" gap={16}>
                                    <Pane flex={1}>
                                        <TextInputField
                                            label="Data Început"
                                            name="startDate"
                                            type="date"
                                            required
                                            value={values.startDate}
                                            onChange={handleChange}
                                            validationMessage={errors.startDate}
                                        />
                                    </Pane>
                                    <Pane flex={1}>
                                        <TextInputField
                                            label="Data Sfârșit"
                                            name="endDate"
                                            type="date"
                                            required
                                            value={values.endDate}
                                            onChange={handleChange}
                                            validationMessage={errors.endDate}
                                        />
                                    </Pane>
                                </Pane>

                                <Pane marginBottom={16}>
                                    <label>Motiv (opțional)</label>
                                    <Textarea
                                        name="reason"
                                        value={values.reason}
                                        onChange={handleChange}
                                        placeholder="Motivul cererii..."
                                    />
                                </Pane>

                                <Pane display="flex" justifyContent="flex-end" gap={8}>
                                    <Button onClick={() => this.setState({ showCreateDialog: false })}>
                                        Anulează
                                    </Button>
                                    <Button type="submit" appearance="primary">
                                        Trimite Cererea
                                    </Button>
                                </Pane>
                            </form>
                        )}
                    </Formik>
                </Dialog>

                {/* Process Dialog */}
                <Dialog
                    isShown={showProcessDialog}
                    title={processAction === 'approve' ? 'Aprobă Cererea' : 'Respinge Cererea'}
                    intent={processAction === 'approve' ? 'success' : 'danger'}
                    onCloseComplete={this.handleCloseProcessDialog}
                    confirmLabel={processAction === 'approve' ? 'Aprobă' : 'Respinge'}
                    onConfirm={processAction === 'approve' ? this.handleApprove : this.handleReject}
                >
                    {selectedRequest && (
                        <Pane>
                            <Pane marginBottom={16}>
                                <strong>Angajat:</strong> {selectedRequest.employee?.user?.name}
                            </Pane>
                            <Pane marginBottom={16}>
                                <strong>Perioadă:</strong> {moment(selectedRequest.startDate).format('DD.MM.YYYY')} - {moment(selectedRequest.endDate).format('DD.MM.YYYY')}
                            </Pane>
                            <Pane marginBottom={16}>
                                <strong>Zile lucrătoare:</strong> {selectedRequest.workingDays}
                            </Pane>
                            {selectedRequest.reason && (
                                <Pane marginBottom={16}>
                                    <strong>Motiv:</strong> {selectedRequest.reason}
                                </Pane>
                            )}
                            <Pane marginTop={16}>
                                <label>Note Administrator (opțional)</label>
                                <Textarea
                                    value={adminNotes}
                                    onChange={(e) => this.setState({ adminNotes: e.target.value })}
                                    placeholder="Note sau observații..."
                                />
                            </Pane>
                        </Pane>
                    )}
                </Dialog>

                {/* Cancel Vacation Dialog */}
                <Dialog
                    isShown={this.state.showCancelDialog}
                    title="Anulează Concediu"
                    intent="danger"
                    onCloseComplete={this.handleCloseCancelDialog}
                    confirmLabel="Anulează Concediul"
                    onConfirm={this.handleCancel}
                >
                    {selectedRequest && (
                        <Pane>
                            <Pane marginBottom={16}>
                                Ești sigur că vrei să anulezi concediul lui <strong>{selectedRequest.employee?.user?.name}</strong>?
                            </Pane>
                            <Pane marginBottom={16}>
                                <strong>Perioadă:</strong> {moment(selectedRequest.startDate).format('DD.MM.YYYY')} - {moment(selectedRequest.endDate).format('DD.MM.YYYY')}
                            </Pane>
                            <Pane padding={12} background="tint1" borderRadius={4}>
                                ⚠️ Turele care au fost anulate din cauza acestui concediu vor fi restaurate automat.
                            </Pane>
                        </Pane>
                    )}
                </Dialog>
            </Pane>
        );
    }
}

function mapStateToProps(state) {
    return {
        vacationRequests: state.scheduleProgram.vacationRequests,
        pendingVacations: state.scheduleProgram.pendingVacations,
        shops: state.scheduleProgram.shops,
        user: state.authentication.user
    };
}

export default connect(mapStateToProps)(VacationRequests);
